import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import styled from "styled-components";
import Button from "sushiweb/Button";
import HorizontalTabs from "sushiweb/HorizontalTabs";
import ListPagination from "../../components/Common/ListPagination";
import Permission from "../../components/Common/Permission";
import FCTaskList from "../../components/FleetCoachTask/FCTaskList";
import initialFormState from "../../constants/FleetCoachTask/index";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../constants/Menu/MenuNames.json";
import SuccessMessages from "../../constants/SucessMessages.json";
import { FlexContainer, Heading } from "../../constants/assets/containers";
import variables from "../../constants/assets/variables";
import * as FleetCoachTaskActions from "../../store/actions/FleetCoachTask";
import * as userActions from "../../store/actions/User";

import { isValNull } from "../../utils";
import FCTaskCreation from "./FCTaskCreation";

const allActions = MenuActionsMappings[MenuNames.FLEET_COACH_TASK];

const Tabs = [
  {
    key: "CREATE_TASK",
    label: "Create Task",
    requiredPerms: allActions.FLEET_COACH_TASK_CREATE,
    type: "create",
  },
  {
    key: "ACTIVE_TASK",
    label: "Active Task",
    requiredPerms: allActions.FLEET_COACH_TASK_VIEW,
    type: "active",
  },
  {
    key: "PAST_TASK",
    label: "Past Task",
    requiredPerms: allActions.FLEET_COACH_TASK_VIEW,
    type: "past",
  },
];

const FleetCoachTask = (props) => {
  const {
    createFleetCoachTask,
    taskList,
    fetchTaskList,
    nextPage,
    prevPage,
    activeFilters,
    setStatus,
  } = props;

  const [initialState, setInitialState] = useState(initialFormState);
  const [formError, setFormError] = useState("");
  const [activeTab, setActiveTab] = useState(Tabs[0]);
  const [currentPage, setCurrentPage] = useState(1);

  const isCreationTab = activeTab.key === Tabs[0].key;
  const isActiveTab = activeTab.key === Tabs[1].key;
  const isPastTab = activeTab.key === Tabs[2].key;

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const validateDetails = () => {
    let err = "";
    for (let key in initialState) {
      if (isValNull(initialState[key])) {
        err = `${key.split("_").join(" ")} is the mandatory field`;
        break;
      }
    }
    return err;
  };

  const handleCreateTask = () => {
    let errorMsg = validateDetails();
    if (errorMsg.length === 0) {
      createFleetCoachTask(initialState).then(() => {
        setInitialState(initialFormState);
        setStatus({
          type: "success",
          message: SuccessMessages.CREATION_SUCCESS,
        });
        setTimeout(() => window.location.reload(), 500);
      });
    } else {
      setFormError(errorMsg);
    }
  };

  const handleNavClick = (action) => {
    if (action === "prev") {
      let pageRequest = {
        page: currentPage - 1,
        page_size: 10,
      };
      setCurrentPage(currentPage - 1);
      fetchTaskList({ ...activeFilters, type: activeTab.type }, pageRequest);
    } else {
      let pageRequest = {
        page: currentPage + 1,
        page_size: 10,
      };
      setCurrentPage(currentPage + 1);
      fetchTaskList({ ...activeFilters, type: activeTab.type }, pageRequest);
    }
  };

  useEffect(() => {
    if (!isCreationTab) {
      fetchTaskList({ ...activeFilters, type: activeTab.type });
    } else setInitialState({ ...initialFormState });
  }, [activeTab]);

  return (
    <Container className="ml-20">
      <FlexContainer align="flex-start" className="mb-32">
        <Heading>Catalyst - tasks for FCs</Heading>
      </FlexContainer>
      <HorizontalTabs
        id="sushi-tabs"
        alignLinks="left"
        className="flex"
        hasThinLine
        appearance="bold"
      >
        {Tabs.map((tab, index) => {
          return (
            <HorizontalTabs.Link
              active={activeTab.key === tab.key}
              onClick={() => handleTabClick(tab)}
              key={`tabs-${index}`}
            >
              {tab.label}
            </HorizontalTabs.Link>
          );
        })}
        {isCreationTab ? (
          <Permission requiredPerms={[allActions.FLEET_COACH_TASK_CREATE]}>
            <Button
              data-testid="nextButton"
              className="submitTask sushi-btn"
              onClick={handleCreateTask}
            >
              Submit Task
            </Button>
          </Permission>
        ) : (
          <React.Fragment></React.Fragment>
        )}
      </HorizontalTabs>
      <Main isCreationTab={isCreationTab}>
        {activeTab.key === Tabs[0].key ? (
          <Permission
            requiredPerms={[allActions.FLEET_COACH_TASK_CREATE]}
            notAllowedText="You don't have role to create task"
          >
            <FCTaskCreation
              initialState={initialState}
              setInitialState={setInitialState}
              setFormError={setFormError}
              formError={formError}
            />
          </Permission>
        ) : (
          <Permission requiredPerms={[allActions.FLEET_COACH_TASK_VIEW]}>
            <FCTaskList taskList={taskList} isActiveTab={isActiveTab} />
            <ListPagination
              nextPage={nextPage}
              prevPage={prevPage}
              handleNavClick={handleNavClick}
            />
          </Permission>
        )}
      </Main>
    </Container>
  );
};

const Container = styled.div`
  margin-left: 20rem;
  .submitTask {
    margin-left: auto;
  }
`;

const Main = styled.div`
  padding: ${(props) => (props.isCreationTab ? "39px 75px" : "39px 32px")};
  border-radius: 8px;
  border: 1px solid ${variables.grey200};
  background: ${variables.white};
  min-height: 70vh;
  margin-top: 25px;
  box-sizing: border-box;
`;

function mapStateToProps(state) {
  const { FleetCoachTask } = state;
  return {
    nextPage: FleetCoachTask.nextPage,
    prevPage: FleetCoachTask.prevPage,
    activeFilters: FleetCoachTask.activeFilters,
    taskList: FleetCoachTask?.FCTaskList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setStatus: bindActionCreators(userActions.setStatus, dispatch),
    createFleetCoachTask: bindActionCreators(
      FleetCoachTaskActions.createFleetCoachTask,
      dispatch
    ),
    fetchTaskList: bindActionCreators(
      FleetCoachTaskActions.fetchTaskList,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FleetCoachTask);
